// removed by extract-text-webpack-plugin
module.exports = {"angleDown":"WeekSelector__angleDown--2pQ4S","weekSelectorMobile":"WeekSelector__weekSelectorMobile--1LPjm","selected":"WeekSelector__selected--29304"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/JumpToWeek/WeekSelector/WeekSelector.css
// module id = iGPa
// module chunks = 47